<div class="card-header">
  <h1>registreren</h1>
</div>
<div class="card-body">
  <p class="mb28">Vul de gegevens van de bewindvoerder in</p>
  <h2>1. logingegevens</h2>
  <form (ngSubmit)="register(form.value)" [formGroup]="form" class="form">
  <!-- username -->
  <div [ngClass]="{ 'input-error': submitted && f.username.errors }">
    <label for="defaultLoginFormEmail" class="form-label">{{'email_address' | translate}}</label>
    <input (input)="checkForEmail($event)" formControlName="username"
           id="defaultLoginFormEmail" type="email">
    <div class="errors">
      <div *ngIf="f.username.errors?.required">{{'email_address.required' | translate}}</div>
      <div *ngIf="f.username.errors?.pattern">{{'email_address.invalid' | translate}}</div>
      <div *ngIf="f.username.errors?.maxlength">{{'email_address.maxLength' | translate}}</div>
    </div>
    <div>
      <div *ngIf="!usernameAvailable && userActivated">
        dit e-mailadres is al in gebruik <br>
        <div (click)="send('PasswordRecoveryMail')" class="link">klik hier om uw wachtwoord te herstellen</div>
      </div>
      <div *ngIf="!usernameAvailable && !userActivated">
        dit e-mailadres is al in gebruik <br>
        <div (click)="send('ActivateMail')" class="link">klik hier om de activatiemail opnieuw te sturen</div>
      </div>
    </div>
  </div>

  <!-- password -->
  <div [ngClass]="{ 'input-error': submitted && f.password.errors }">
    <label for="password" class="form-label">{{'password' | translate}}</label>
    <div class="relative">
      <input formControlName="password" appShowPasswordToggle id="password" type="password">
    </div>
    <div class="errors">
      <div *ngIf="f.password.errors?.required">{{'password.required' | translate}}</div>
      <div *ngIf="f.password.errors?.minlength">{{'password.minLength' | translate}}</div>
    </div>
  </div>

  <!-- password2 -->
  <div [ngClass]="{ 'input-error': submitted && f.password2.errors }">
    <label for="password2" class="form-label">herhaal wachtwoord</label>
    <div class="relative">
      <input formControlName="password2" appShowPasswordToggle id="password2" type="password">
    </div>
    <div *ngIf="submitted && f.password2.errors" class="errors">
      <div *ngIf="f.password2.errors?.required">{{'password.required' | translate}}</div>
      <div *ngIf="f.password2.errors?.minlength">{{'password.minLength' | translate}}</div>
    </div>
  </div>
  <div *ngIf="showCheckPasswordError" class="error">de wachtwoorden komen niet overeen</div>
  <div *ngIf="message" class="error">{{message}}</div>
  <small class="small-text">besteed aandacht aan uw wachtwoord. voorkom toegang door derden</small>

  <div class="spacer"></div>

  <!-- howDidYouFindUsOptions -->
  <div>
    <label for="howDidYouFindUs" class="form-label">hoe bent u bekend geraakt met Reveon? (optioneel)</label>
    <app-select formControlName="howDidYouFindUs"
                id="howDidYouFindUs"
                [options]="howDidYouFindUsOptions"></app-select>
  </div>

  <div class="spacer-large"></div>
  <h2>2. persoons<wbr>gegevens</h2>
  <p>deze worden gebruikt voor het genereren van de rapportages</p>


    <!-- firstNameInitials -->
    <div [ngClass]="{ 'input-error': submitted && f.firstNameInitials.errors }">
      <label for="firstNameInitials" class="form-label">{{'name.first_name_initials' | translate}}</label>
      <input formControlName="firstNameInitials" id="firstNameInitials" type="text">
      <div class="errors">
        <div *ngIf="f.firstNameInitials.errors?.required"> {{'name.first_name_initials.required' | translate}}</div>
        <div *ngIf="f.firstNameInitials.errors?.maxlength">{{'name.first_name_initials.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- firstName -->
    <div [ngClass]="{ 'input-error': submitted && f.firstName.errors }">
      <label for="firstName" class="form-label">{{'name.first_name' | translate}}</label>
      <input formControlName="firstName" id="firstName" type="text">
      <div class="errors">
        <div *ngIf="f.firstName.errors?.required"> {{'name.first_name.required' | translate}}</div>
        <div *ngIf="f.firstName.errors?.maxlength">{{'name.first_name.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- insertion -->
    <div [ngClass]="{ 'input-error': submitted && f.insertion.errors }">
      <label for="insertion" class="form-label">{{'name.insertion' | translate}}</label>
      <input formControlName="insertion" id="insertion" type="text">
      <div class="errors">
        <div *ngIf="f.insertion.errors?.maxlength">{{'name.insertion.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- lastName -->
    <div [ngClass]="{ 'input-error': submitted && f.lastName.errors }">
      <label for="lastName" class="form-label">{{'name.last_name' | translate}}</label>
      <input formControlName="lastName" id="lastName" type="text">
      <div class="errors">
        <div *ngIf="f.lastName.errors?.required">{{'name.last_name.required' | translate}}</div>
        <div *ngIf="f.lastName.errors?.maxlength">{{'name.last_name.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- phone-->
    <div [ngClass]="{ 'input-error': submitted && f.phone.errors }">
      <label for="phone" class="form-label">{{'phone' | translate}}</label>
      <input formControlName="phone" id="phone" type="text">
      <div class="errors">
        <div *ngIf="f.phone.errors?.required">{{'phone.required' | translate}}</div>
        <div *ngIf="f.phone.errors?.maxlength">{{'phone.last_name.maxLength' | translate}}</div>
      </div>
    </div>

    <div class="spacer-large"></div>
    <h2>3. adresgegevens</h2>
    <!-- street -->
    <div [ngClass]="{ 'input-error': submitted && f.street.errors }">
      <label for="street" class="form-label">{{'address.street' | translate}}</label>
      <input formControlName="street" id="street" type="text">
      <div class="errors">
        <div *ngIf="f.street.errors?.required">{{'address.street.required' | translate}}</div>
        <div *ngIf="f.street.errors?.maxlength">{{'address.street.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- houseNumber -->
    <div [ngClass]="{ 'input-error': submitted && f.houseNumber.errors }">
      <label for="houseNumber" class="form-label">{{'address.house_number' | translate}}</label>
      <input formControlName="houseNumber" id="houseNumber" type="text">
      <div class="errors">
        <div *ngIf="f.houseNumber.errors?.required">{{'address.house_number.required' | translate}}</div>
        <div *ngIf="f.houseNumber.errors?.maxlength">{{'address.house_number.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- houseNumberSuffix -->
    <div [ngClass]="{ 'input-error': submitted && f.houseNumberSuffix.errors }">
      <label for="houseNumberSuffix" class="form-label">{{'address.house_number_suffix' | translate}}</label>
      <input formControlName="houseNumberSuffix" id="houseNumberSuffix" type="text">
      <div class="errors">
        <div *ngIf="f.houseNumberSuffix.errors?.required">{{'address.house_number_suffix.required' | translate}}</div>
        <div *ngIf="f.houseNumberSuffix.errors?.maxlength">{{'address.house_number_suffix.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- zipCode -->
    <div [ngClass]="{ 'input-error': submitted && f.zipCode.errors }">
      <label for="zipCode" class="form-label">{{'address.zip_code' | translate}}</label>
      <input formControlName="zipCode" id="zipCode" type="text">
      <div class="errors">
        <div *ngIf="f.zipCode.errors?.required">{{'address.zip_code.required' | translate}}</div>
        <div *ngIf="f.zipCode.errors?.maxlength">{{'address.zip_code.maxLength' | translate}}</div>
      </div>
    </div>

    <!-- city -->
    <div [ngClass]="{ 'input-error': submitted && f.city.errors }">
      <label for="city" class="form-label">{{'address.city' | translate}}</label>
      <input formControlName="city" id="city" type="text">
      <div class="errors">
        <div *ngIf="f.city.errors?.required">{{'address.city.required' | translate}}</div>
        <div *ngIf="f.city.errors?.maxlength">{{'address.city.maxLength' | translate}}</div>
      </div>
    </div>

    <div class="spacer"></div>
    <!-- legal -->
    <div class="mt14 mb14" style="text-align:left;">
      <input class="left" formControlName="agreed" id="terms-and-condition" style="position:relative;top:1px;"
             type="checkbox">
      <label class="small-text unselectable" for="terms-and-condition">
        ik ga akkoord met de
        <a href="https://www.reveon.nl/algemene-voorwaarden" target="_blank" class="link">
          algemene voorwaarden
        </a>
        en de
        <a href="https://www.reveon.nl/privacy-statement" target="_blank" class="link">
        verwerkersovereenkomst
        </a>
      </label>
    </div>
    <div *ngIf="submitted && f.agreed.status === 'INVALID'" class="error" >
      <div>Ga akkoord met de algemene voorwaarden en de verwerkersovereenkomst</div>
    </div>
    <div class="spacer"></div>

    <button class="btn btn-left mr16 arrow-left" routerLink="/login">annuleer</button>
    <button *ngIf="!isLoading" class="btn check inverted accent" type="submit">registreer <span class="hide-on-phone">bewindvoerder</span></button>
  </form>
  <!-- Default form login -->
</div>
